module.exports = __webpack_public_path__ + "img/core42-hcms.0305ecfc.svg";